import React from "react";
import { Typography, Container, Grid } from "@mui/material";
import "../../styles/components/StatsSection.css";

function StatsSection() {
  const stats = [
    {
      number: "5+",
      label: "Years Experience",
    },
    {
      number: "50+",
      label: "Projects Completed",
    },
    {
      number: "100%",
      label: "Client Satisfaction",
    },
    {
      number: "24/7",
      label: "Support Available",
    },
  ];

  return (
    <section className="stats-section-wrapper">
      <Container>
        <Grid
          container
          rowSpacing={{ xs: 2, sm: 3, md: 4 }}
          columnSpacing={{ xs: 0, sm: 3, md: 4 }}
        >
          {stats.map((stat, index) => (
            <Grid item xs={12} sm={6} md={3} key={stat.label}>
              <div className="stat-item">
                <Typography
                  variant="h2"
                  component="div"
                  color="primary"
                  gutterBottom
                >
                  {stat.number}
                </Typography>
                <Typography variant="h6" component="div">
                  {stat.label}
                </Typography>
              </div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </section>
  );
}

export default StatsSection;
